import { usePopup } from '@contexts/popupContext';
import styles from '@styles/components/Configuracion/Novedades/ConfiguracionNovedadesDias.module.css';
import { useEffect, useState } from 'react';
import Utils from '@utils/Utils';
import { DateMultiPicker } from '@components/General/DatePicker';
import ResultPopup from '@components/General/ResultPopup';
import { DayPickerReusable } from '@components/General/TablePoppers';
import { Application } from '@core/Application';
import { WorkingDaysRequest, HolidaysRequest } from '@services/NovedadesService';

const ConfiguracionNovedadesDias = ({orgID, timezone}) => {
    const {showPopup} = usePopup()

    const [selectedDays, setSelectedDays] = useState([])
    const [selectedDates, setSelectedDates] = useState([])

    useEffect(() => {
        fetchFeriados()
        fetchWorkingDays()
    }, [orgID])


    const handleCancelDays = async () => {
        setSelectedDays([])
    }

    const handleCommitDays = async () => {
        const data: WorkingDaysRequest = {
            days: selectedDays
        };
        
        try {
            const novedadesService = Application.shared().coreDependencies.novedadesService;
            await novedadesService.setConfigurationDias(orgID, data);
            showPopup(() => <ResultPopup result={"Dias guardados correctamente!"} succesful={true}/>)

        } catch (error) {
            showPopup(() => <ResultPopup result={"Error al guardar dias."} succesful={false}/>)
            console.error(error)
        }
    }

    const handleCancelDates = async () => {
        setSelectedDates([])
    }

    const handleCommitDates = async () => {
        let formattedDates = []
        for (let selectedDate of selectedDates) {
            let formattedDate = Utils.getDayStringFromTimestamp(selectedDate.getTime(), timezone)
            formattedDates.push(formattedDate)
        }

        const data: HolidaysRequest = {
            dates: formattedDates
        };
        
        try {
            const novedadesService = Application.shared().coreDependencies.novedadesService;
            await novedadesService.setConfigurationFeriados(orgID, data);
            showPopup(() => <ResultPopup result={"Fechas guardadas correctamente!"} succesful={true}/>)

        } catch (error) {
            showPopup(() => <ResultPopup result={"Error al guardar fechas."} succesful={false}/>)
            console.error(error)
        }
    }


    
    const fetchWorkingDays = async () => {
        const transformWorkingDaysToDaysArray = (workingDays) => {
            const daysMap = {
                monday: "Lunes",
                tuesday: "Martes",
                wednesday: "Miercoles",
                thursday: "Jueves",
                friday: "Viernes",
                saturday: "Sabado",
                sunday: "Domingo"
            };
        
            const daysArray = [];
        
            for (const [key, value] of Object.entries(workingDays)) {
                if (value) {
                    const day = daysMap[key];
                    if (day) {
                        daysArray.push(day);
                    }
                }
            }
        
            return daysArray;
        };

        try {
            const novedadesService = Application.shared().coreDependencies.novedadesService;
            const json = await novedadesService.getConfigurationDias(orgID);
            setSelectedDays(transformWorkingDaysToDaysArray(json))
        } catch (error) {
            console.error(error)
        }
    }

    const fetchFeriados = async () => {
        const transformFeriadosToDates = (feriados) => {
            const datesArray = [];
            for (let date of feriados) {
                const [year, month, day] = date.split('-').map(Number);
                const localDate = new Date(year, month - 1, day);
                datesArray.push(localDate);
            }
        
            return datesArray;
        };

        try {
            const novedadesService = Application.shared().coreDependencies.novedadesService;
            const json = await novedadesService.getConfigurationFeriados(orgID);
            console.log(json)

            setSelectedDates(transformFeriadosToDates(json))
        } catch (error) {
            console.error(error)
        }
    }


    return (
    <div className={styles['content-block']}>
        <div className={styles["main-grid"]}>
            {/*Info dias laborales */}
            <div className={styles["grid-info"]}>
                <p className={styles["info-title"]}>Dias laborales</p>
                <p className={styles["info-text"]}>
                    Especificar los días que conforman la semana laboral en tu Organización. 
                    Los días no seleccionados se mostrarán como días de Franco en el calendario del Reporte de Novedades.
                </p>
            </div>

            {/*Dias laborales */}
            <div className={styles["grid-picker"]}>
                <DayPickerReusable 
                    days={selectedDays} 
                    setDays={setSelectedDays}
                    style={{height: "auto"}}
                />
                <div className={styles['daypicker-actions-container']}>
                    <div className={`${styles['daypicker-button']} ${styles['daypicker-button-cancelar']}`} onClick={handleCancelDays}>Cancelar</div>
                    <div className={`${styles['daypicker-button']} ${styles['daypicker-button-aceptar']}`} onClick={handleCommitDays}>Aceptar</div>
                </div>
            </div>

            {/*Info feriados */}
            <div className={styles["grid-info"]}>
                <p className={styles["info-title"]}>Feriados o días festivos</p>
                <p className={styles["info-text"]}>
                    Seleccionar los días del año que corresponden a feriados u otros días no laborales en tu Organización.
                </p>
            </div>

            {/*Feriados */}
            <div className={styles["grid-picker"]} style={{justifyContent: "flex-start"}}>
                <DateMultiPicker
                    dates={selectedDates}
                    updateDates={setSelectedDates}
                />
                <div className={styles['daypicker-actions-container']} style={{marginTop: "10px"}}>
                    <div className={`${styles['daypicker-button']} ${styles['daypicker-button-cancelar']}`} onClick={handleCancelDates}>Cancelar</div>
                    <div className={`${styles['daypicker-button']} ${styles['daypicker-button-aceptar']}`} onClick={handleCommitDates}>Aceptar</div>
                </div>
            </div>
        </div>
    </div>
    );
};

export default ConfiguracionNovedadesDias